/** Who can see a record (ADR 0012): both sides, or the agency only. */
export const VISIBILITIES = ["shared", "agency_only"] as const;
export type Visibility = (typeof VISIBILITIES)[number];

export const VISIBILITY_LABELS: Record<Visibility, string> = {
  shared: "Shared with the client",
  agency_only: "Agency only",
};
